import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.8176 4.39632C18.1334 2.66418 15.7363 1.84678 13.0457 2.09515C10.421 2.33851 7.8357 3.58036 5.76643 5.59165C1.45325 9.78458 0.738208 16.0704 4.17315 19.6034C5.65907 21.1323 7.70543 21.9482 10.0095 21.9482C10.3165 21.9482 10.6286 21.9339 10.945 21.9046C13.5697 21.6612 16.155 20.4194 18.2236 18.4081C20.2928 16.3968 21.6077 13.848 21.9255 11.2304C22.2504 8.55633 21.5025 6.12918 19.8176 4.39632Z",
  fill: "#DAE9FF"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.9812 2.05179C13.6742 2.05179 13.3621 2.0661 13.0457 2.09545C10.421 2.33881 7.8357 3.58066 5.76643 5.59194C1.45325 9.78488 0.738208 16.0707 4.17315 19.6037C5.65907 21.1326 7.70543 21.9485 10.0095 21.9485C10.3165 21.9485 10.6286 21.9342 10.945 21.9049C13.5697 21.6608 16.155 20.4189 18.2243 18.4077C20.2928 16.3964 21.6077 13.8475 21.9255 11.2307C22.2511 8.55591 21.5025 6.12948 19.8176 4.39662C18.3316 2.86776 16.2896 2.05179 13.9812 2.05179ZM13.981 3.12546C16.0116 3.12546 17.7638 3.82405 19.0478 5.14463C20.5015 6.63985 21.145 8.75564 20.8594 11.1012C20.571 13.4754 19.3692 15.7973 17.4753 17.6382C15.5814 19.4792 13.2273 20.6144 10.8452 20.8356C10.5632 20.862 10.2826 20.8749 10.0092 20.8749C7.97858 20.8749 6.22711 20.1763 4.94232 18.855C3.51008 17.3813 2.86661 15.2905 3.13073 12.9665C3.40415 10.5629 4.60591 8.21739 6.51485 6.36214C8.40804 4.5212 10.7629 3.38528 13.1442 3.16483C13.4255 3.13835 13.7068 3.12546 13.981 3.12546Z",
  fill: "#C8DDFF"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.437 16.6315C9.86077 16.6315 9.54297 16.3037 9.54297 15.6781V8.59853C9.54297 7.95292 9.89083 7.60506 10.5364 7.60506H13.927C14.5626 7.60506 14.8904 7.90281 14.8904 8.39955C14.8904 8.89629 14.5626 9.20407 13.927 9.20407H11.3309V11.2497H13.3859C14.0315 11.2497 14.3099 11.4981 14.3099 11.9941C14.3099 12.4908 14.0315 12.7392 13.3859 12.7392H11.3309V15.6781C11.3309 16.3037 11.0232 16.6315 10.437 16.6315Z",
  fill: "#458FFF"
}, null, -1);
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_4);
}
const icV2StoveFlakeColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2StoveFlakeColor as default
};
